import { ActivatedRoute } from '@angular/router';

import { Component } from '@angular/core';
import { AbstractComponent } from '../../../../../core/common/component/AbstractComponent';

import { AuthService } from 'src/app/common/service/AuthService';
import { Title } from '@angular/platform-browser';
import { TenantCameraService } from './TenantCameraService';
import { ToastrService } from 'ngx-toastr';
import { GSAlertDialogComponent } from 'src/app/directives/gs-alert/GSAlertDialogComponent';
import { MatDialog } from '@angular/material/dialog';



@Component({
  selector: 'app-tenant-camera',
  templateUrl: './TenantCamera.html',
  styleUrls: ['./TenantCamera.scss']
})
export class TenantCameraComponent extends AbstractComponent {

  public scope = {
    wait : false,
    tenantCd : '',
    cameras : [],
    hover: false
  }

  public constructor(
    private title: Title,
    private service : TenantCameraService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private authService: AuthService, 
    private route: ActivatedRoute) {
    super();
    this.title.setTitle("Tenant Camera list");
    
  }
  /**  */
  public componentWillMount() {
  }


  /** 表示 */
  public render() {
    this.route.params.subscribe(params => {
      this.scope.tenantCd = params.tenantCd;
      this.renderList();
    });
  }
  /** 表示 */
  public renderList() {
    this.service.get(this.scope.tenantCd).subscribe((res:any) => {
      this.scope.cameras = res;
    });
  }


  public getCapture(id) {
    return this.service.getCapture(id);
  }

  public isAllCehck() {
    if (this.scope.cameras.find(e => e.select )) {
      return true;
    } else {
      return false;
    }
  }

  public allToggle() {
    if (this.isAllCehck()) {
      this.scope.cameras.map(e => e.select = false);
    } else {
      this.scope.cameras.map(e => e.select = true);
    }
  }
  
  public toggle(menu) {
    menu.select = !menu.select;
  }

  public mouseover(e) {
    console.log("over");
    this.scope.hover = true;
  }
  public mouseout(e) {
    console.log("out");
    this.scope.hover = false;
  }
  
  public save() {
    
    const dialogRef = this.dialog.open(GSAlertDialogComponent, {
      disableClose : true,
      width : "500px",
      data : { message : "公開設定した内容でよろしいですか？",
               caption : "設定したカメラがユーザに表示されます。 "
             }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.status == 'SUCCESS') {
        this.service.save(this.scope.tenantCd, this.scope.cameras).subscribe(e => {
          this.toastr.success('Tenant camera setting is successful');
          this.renderList();
        });

      }
    }, error => {
      console.log(error)
    });
  }
}
